module.exports = __webpack_public_path__ + "img/information-svgrepo-com.65568ea5.svg";